import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import usePaginator from "../../../theme/Component/usePaginator";
import { _AddCommercialCampaign, _CommercialCampaign, _CustomerAddress } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { AccountantYear } from "../../../Talentohumano/GestionTH/EmployeeContract/ProductionPlan/AccountantYear";
import { MonthEditorbyconst } from "../../../RemoteAbstractAction/editors/MonthEditorbyconst";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { SelectProductEditor } from "../../../Factoty&Production/ManufacturingStandars/Components/SelectProductEditor";
import { InputDate } from "../../../theme/Input/InputDate";
import { AccountEditor } from "../../../editor/AccountEditor";
import { SelectSiteID } from "../../../admin/configuracion/SiteID/SelectSiteID";


export const CustomerAddress = () => {

    const cusAdd = useDataBean(_CustomerAddress);
    const paginador = usePaginator();
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [Account, setAccount] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        cusAdd.instance.getCustomerAddressCatalog(Account, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    // setLista(resp.List)
                    let x = resp.List;
                    x.forEach((user) => {
                        user.DataBeanProperties.Client = (user.DataBeanProperties.AccountNit ?? "") + "-" + (user.DataBeanProperties.AccountName ?? "");
                    });
                    setLista(x)
                }
            }
        )

    }
    const create = () => {
        cusAdd.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        cusAdd.instance.deleteCustomerAddress(cusAdd.bean.IDCustomerAddress).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        cusAdd.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDCustomerAddress', visible: true },
        { title: 'Tercero', property: 'Client', visible: true },
        { title: 'Ubicación Geográfica', property: 'SiteIDName', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Dirección', property: 'Address', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Direcciones Comerciales">
            <div className="row">
                <div className="col-md-4">
                    <AccountEditor label="Tercero" idAccount={Account} onChange={(e) => { setAccount(e.IDAccount) }}></AccountEditor>
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={cusAdd.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={cusAdd.bean.Name} onChange={cusAdd.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <AccountEditor label="Tercero" idAccount={cusAdd.bean.IDAccount} onChange={(e) => { cusAdd.setBean({ ...cusAdd.bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                            </div>
                            <div className="col-md-6">
                                <SelectSiteID edit idLnSite={cusAdd.bean.IDLnSiteID} label="Ubicación Geográfica" onChange={(e) => { cusAdd.setBean({ ...cusAdd.bean, "IDLnSiteID": e.IDLn }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <input type="text" name="Description" className="form-control" value={cusAdd.bean.Description} onChange={cusAdd.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {cusAdd.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}